import { render, staticRenderFns } from "./bible-study.vue?vue&type=template&id=79af798f"
import script from "./bible-study.vue?vue&type=script&lang=js"
export * from "./bible-study.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports